// Non-blocking toast with an optional "Rückgängig" (undo) action.
// Replaces native confirm()/alert() for destructive operations.
let wrap: HTMLElement | null = null;

export function initToast(el: HTMLElement): void {
  wrap = el;
}

export function toast(message: string, undo?: () => void): void {
  if (!wrap) return;
  const box = document.createElement("div");
  box.className = "toast";
  const span = document.createElement("span");
  span.textContent = message;
  box.appendChild(span);

  const timer = setTimeout(() => box.remove(), 6000);

  if (undo) {
    const btn = document.createElement("button");
    btn.textContent = "Rückgängig";
    btn.addEventListener("click", () => {
      clearTimeout(timer);
      undo();
      box.remove();
    });
    box.appendChild(btn);
  }
  wrap.appendChild(box);
}
